const IconChevronLeft = (): JSX.Element => {
  return (
    <>
      <path
        d="M11.1047 0L13.7143 2.50667L5.23771 10.6667L13.7143 18.8267L11.1047 21.3333L0 10.6667L11.1047 0Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconChevronLeft;
